import { Injectable } from "@angular/core";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { environment } from "@edp-environments/environment";
import { IDevice } from "@edp-models/device.model";
import { getDevice } from "@edp-store/selectors/notifications.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "./app.service";

@Injectable({
    providedIn: "root",
})
export class CopyClipboardService {
    constructor(
        private readonly appService: AppService,
        private readonly toaster: EdpToasterService,
        private readonly translate: TranslateService,
        private readonly store: Store<IAppState>
    ) {}

    copyToClipboard(copy: string) {
        if (!environment.isApp) {
            this.callBrowserCopy(copy);
            return;
        }

        this.store.pipe(select(getDevice)).subscribe((device: IDevice) => {
            if (!device) {
                return;
            }

            const appVersion = Number(device.AppVersion.replace(/[^0-9|]/g, ""));
            if (appVersion >= 6230) {
                this.appService.copyToClipboard(copy);
                this.showCopySuccessMessage();
                return;
            }
            this.callBrowserCopy(copy);
        });
    }

    private callBrowserCopy(copy: string) {
        const listener = (e: ClipboardEvent) => {
            e.clipboardData.setData("text/plain", copy);
            e.preventDefault();
        };

        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
        this.showCopySuccessMessage();
    }

    private showCopySuccessMessage() {
        this.toaster
            .create(this.translate.instant("pt.edp.edponline.code.generation.toaster.copy.success"), EdpToastType.success, {
                timeout: 2000,
            })
            .show();
    }
}
